import React, { useState, useEffect } from 'react';
import api from '../../api/api';
import AdminLayout from '../../components/AdminLayuot';

function AdminPagos() {
    // --- ESTADOS GLOBALES ---
    const [activeTab, setActiveTab] = useState('DEUDAS'); // 'DEUDAS' | 'HISTORIAL'
    const [loading, setLoading] = useState(true);
    
    // Datos
    const [saldos, setSaldos] = useState([]);      
    const [pagos, setPagos] = useState([]);        
    const [usuarios, setUsuarios] = useState([]);  

    // --- FILTROS (Inicializados en "Ver Todo" para evitar confusiones) ---
    const [filterClientId, setFilterClientId] = useState(''); // '' = Todos
    const [filterMonth, setFilterMonth] = useState('-1');     // '-1' = Todo el Año
    const [filterYear, setFilterYear] = useState('-1');       // '-1' = Todos los Años (Histórico)

    // Modal
    const [showModal, setShowModal] = useState(false);
    const [newPago, setNewPago] = useState({
        usuarioId: '',
        cantidad: '',
        fecha: new Date().toISOString().split('T')[0]
    });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const config = { headers: { Authorization: `Bearer ${token}` } };

            const [saldosRes, pagosRes, usersRes] = await Promise.all([
                api.get('/pagos/saldos-globales', config),
                api.get('/pagos', config),
                api.get('/users', config)
            ]);

            // 1. PROCESAR SALDOS (Deudas)
            const sortedSaldos = saldosRes.data.sort((a, b) => {
                const getDays = (item) => {
                    if (item.saldoPorPagar <= 0 || !item.ultimaEntrega) return -1;
                    return (new Date() - new Date(item.ultimaEntrega));
                };
                return getDays(b) - getDays(a);
            });
            setSaldos(sortedSaldos);

            // 2. PROCESAR PAGOS (Historial)
            if (Array.isArray(pagosRes.data)) {
                const pagosConUsuario = pagosRes.data.map(p => ({
                    ...p,
                    usuario: usersRes.data.find(u => u.id === p.usuarioId) || p.usuario
                }));
                // Ordenar por fecha descendente
                setPagos(pagosConUsuario.sort((a, b) => new Date(b.fecha) - new Date(a.fecha)));
            }

            // 3. PROCESAR USUARIOS (Para el select)
            if (Array.isArray(usersRes.data)) {
                const clientes = usersRes.data.filter(u => u.rol === 'Cliente' && u.isActive !== false);
                setUsuarios(clientes);
            }

        } catch (error) {
            console.error("Error cargando finanzas:", error);
        } finally {
            setLoading(false);
        }
    };

    // --- ACCIONES ---
    const openModalEmpty = () => {
        setNewPago({ usuarioId: '', cantidad: '', fecha: new Date().toISOString().split('T')[0] });
        setShowModal(true);
    };

    const openModalWithClient = (saldoItem) => {
        setNewPago({ 
            usuarioId: saldoItem.cliente.id, 
            cantidad: saldoItem.saldoPorPagar > 0 ? saldoItem.saldoPorPagar : '', 
            fecha: new Date().toISOString().split('T')[0] 
        });
        setShowModal(true);
    };

    const handleCreatePago = async (e) => {
        e.preventDefault();
        if (!newPago.usuarioId || !newPago.cantidad) return alert("Faltan datos.");

        try {
            const token = localStorage.getItem('token');
            // Forzar mediodía para evitar problemas de zona horaria al guardar
            const fechaCorregida = new Date(newPago.fecha + 'T12:00:00'); 

            await api.post('/pagos', {
                usuarioId: newPago.usuarioId,
                cantidad: parseFloat(newPago.cantidad),
                fecha: fechaCorregida
            }, { headers: { Authorization: `Bearer ${token}` } });

            alert('✅ Pago registrado.');
            setShowModal(false);
            fetchData(); 

        } catch (error) {
            console.error(error);
            alert("Error al registrar.");
        }
    };

    const handleDeletePago = async (id) => {
        if (!window.confirm("¿Eliminar este pago?")) return;
        try {
            const token = localStorage.getItem('token');
            await api.delete(`/pagos/${id}`, { headers: { Authorization: `Bearer ${token}` } });
            fetchData();
        } catch (error) { alert("Error al eliminar."); }
    };

    // --- LÓGICA DE FILTRADO ROBUSTA (Corregida) ---
    const pagosFiltrados = pagos.filter(p => {
        if (!p.fecha) return false;

        // TRUCO: Leemos el string directamente (YYYY-MM-DD) para ignorar la zona horaria del navegador
        // p.fecha suele venir como "2025-01-20T00:00:00.000Z" o "2025-01-20"
        const fechaStr = String(p.fecha); 
        const yearStr = fechaStr.substring(0, 4);   // "2025"
        const monthStr = fechaStr.substring(5, 7);  // "01" (Enero es 01)
        
        const pYear = parseInt(yearStr);
        const pMonth = parseInt(monthStr) - 1; // Convertir a índice 0-11 para coincidir con Select

        // 1. Filtro Cliente
        if (filterClientId && p.usuarioId !== filterClientId) return false;

        // 2. Filtro Año (Si no es "Todos")
        if (parseInt(filterYear) !== -1 && pYear !== parseInt(filterYear)) return false;

        // 3. Filtro Mes (Si no es "Todo el año")
        if (parseInt(filterMonth) !== -1 && pMonth !== parseInt(filterMonth)) return false;

        return true;
    });

    const totalIngresosFiltrados = pagosFiltrados.reduce((acc, p) => acc + (p.cantidad || 0), 0);
    const totalDeudaGlobal = saldos.reduce((acc, curr) => acc + curr.saldoPorPagar, 0);

    // --- CONSTANTES ---
    const MESES = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    
    // Generamos años disponibles basados en los datos reales (o defaults)
    const currentY = new Date().getFullYear();
    // Años fijos + Dinámicos
    const YEARS = [currentY, currentY - 1, currentY - 2]; 

    // --- ESTILOS ---
    const THEME = {
        primary: '#1F2937', secondary: '#3B82F6', success: '#10B981', danger: '#EF4444', 
        bg: '#F3F4F6', white: '#FFFFFF', border: '#E5E7EB'
    };
    
    const cardKpi = { background: 'white', padding: 20, borderRadius: 12, boxShadow: '0 4px 6px rgba(0,0,0,0.05)', flex: 1, textAlign: 'center', border: `1px solid ${THEME.border}` };
    const tableStyle = { width: '100%', borderCollapse: 'collapse', marginTop: 20, background: '#fff', borderRadius: 8, overflow: 'hidden', fontSize: 14 };
    const thStyle = { background: THEME.primary, color: 'white', padding: '12px 15px', textAlign: 'left' };
    const tdStyle = { padding: '12px 15px', borderBottom: `1px solid ${THEME.border}`, color: '#333' };
    const tabBtn = (isActive) => ({
        padding: '10px 20px', cursor: 'pointer', fontWeight: 'bold', border: 'none', background: 'transparent',
        borderBottom: isActive ? `3px solid ${THEME.secondary}` : '3px solid transparent',
        color: isActive ? THEME.secondary : '#6B7280', fontSize: 15
    });
    const selectStyle = { padding: '8px 12px', borderRadius: 6, border: '1px solid #ddd', fontSize: 14, minWidth: 150 };

    if (loading) return <AdminLayout title="Finanzas"><div style={{textAlign:'center', marginTop:50}}>Cargando...</div></AdminLayout>;

    return (
        <AdminLayout title="Finanzas y Pagos">
            
            {/* 1. KPIs SUPERIORES */}
            <div style={{ display: 'flex', gap: 20, marginBottom: 30 }}>
                <div style={cardKpi}>
                    <h3 style={{ margin: 0, color: '#6B7280', fontSize: 13, textTransform: 'uppercase' }}>Deuda Global (Por Cobrar)</h3>
                    <p style={{ fontSize: 32, fontWeight: '900', color: THEME.danger, margin: '5px 0' }}>
                        ${totalDeudaGlobal.toLocaleString('es-MX')}
                    </p>
                </div>
                
                {/* KPI DINÁMICO SEGÚN FILTROS */}
                <div style={cardKpi}>
                    <h3 style={{ margin: 0, color: '#6B7280', fontSize: 13, textTransform: 'uppercase' }}>Ingresos (Filtro Actual)</h3>
                    <p style={{ fontSize: 32, fontWeight: '900', color: THEME.success, margin: '5px 0' }}>
                        ${totalIngresosFiltrados.toLocaleString('es-MX')}
                    </p>
                    <span style={{fontSize:11, color: '#9CA3AF'}}>
                        {parseInt(filterMonth) === -1 ? 'Todo el Año' : MESES[filterMonth]} 
                        {parseInt(filterYear) === -1 ? ' (Histórico)' : ` ${filterYear}`}
                    </span>
                </div>

                <div style={{...cardKpi, display:'flex', alignItems:'center', justifyContent:'center', background: THEME.secondary, color:'white', cursor:'pointer'}} onClick={openModalEmpty}>
                    <div style={{fontSize: 20, fontWeight:'bold'}}>+ Registrar Pago</div>
                </div>
            </div>

            {/* 2. PESTAÑAS */}
            <div style={{ borderBottom: `1px solid ${THEME.border}`, marginBottom: 20, display:'flex', gap: 10 }}>
                <button onClick={() => setActiveTab('DEUDAS')} style={tabBtn(activeTab === 'DEUDAS')}>📉 Cuentas por Cobrar</button>
                <button onClick={() => setActiveTab('HISTORIAL')} style={tabBtn(activeTab === 'HISTORIAL')}>💰 Historial de Pagos</button>
            </div>

            {/* VISTA 1: TABLA DE DEUDAS */}
            {activeTab === 'DEUDAS' && (
                <div style={{ background: 'white', borderRadius: 12, boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', overflowX: 'auto' }}>
                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <th style={thStyle}>Cliente</th>
                                <th style={thStyle}>Estado</th>
                                <th style={thStyle}>Deuda ($)</th>
                                <th style={thStyle}>Deuda (Kg)</th>
                                <th style={thStyle}>Última Entrega</th>
                                <th style={thStyle}>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {saldos.map((s, i) => {
                                const now = new Date();
                                const last = s.ultimaEntrega ? new Date(s.ultimaEntrega) : null;
                                const days = last ? Math.floor((now - last)/(86400000)) : 0;
                                const isOverdue = s.saldoPorPagar > 0 && days > 30;

                                return (
                                    <tr key={i} style={{ background: isOverdue ? '#FEF2F2' : 'white' }}>
                                        <td style={tdStyle}>
                                            <div style={{fontWeight:'bold'}}>{s.cliente.negocio || s.cliente.username}</div>
                                            <div style={{fontSize:11, color:'#6B7280'}}>{s.cliente.username}</div>
                                        </td>
                                        <td style={tdStyle}>
                                            {isOverdue ? (
                                                <span style={{background:'#FEE2E2', color:'#991B1B', padding:'2px 8px', borderRadius:10, fontSize:11, fontWeight:'bold', border:'1px solid #FCA5A5'}}>⚠️ VENCIDO (+{days}d)</span>
                                            ) : s.saldoPorPagar > 0 ? (
                                                <span style={{background:'#FEF3C7', color:'#92400E', padding:'2px 8px', borderRadius:10, fontSize:11, fontWeight:'bold'}}>PENDIENTE</span>
                                            ) : (
                                                <span style={{background:'#D1FAE5', color:'#065F46', padding:'2px 8px', borderRadius:10, fontSize:11, fontWeight:'bold'}}>AL DÍA</span>
                                            )}
                                        </td>
                                        <td style={{...tdStyle, fontWeight:'bold', color: s.saldoPorPagar > 0 ? THEME.danger : THEME.success}}>
                                            ${s.saldoPorPagar.toLocaleString('es-MX')}
                                        </td>
                                        <td style={tdStyle}>{s.kgPorPagar.toFixed(1)} Kg</td>
                                        <td style={tdStyle}>{s.ultimaEntrega ? new Date(s.ultimaEntrega).toLocaleDateString() : '-'}</td>
                                        <td style={tdStyle}>
                                            {s.saldoPorPagar > 0 && (
                                                <button 
                                                    onClick={() => openModalWithClient(s)}
                                                    style={{background: THEME.secondary, color:'white', border:'none', padding:'6px 12px', borderRadius:6, cursor:'pointer', fontWeight:'bold', fontSize:12}}
                                                >
                                                    💲 Cobrar
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    {saldos.length === 0 && <div style={{padding:30, textAlign:'center', color:'#666'}}>No hay deudas pendientes.</div>}
                </div>
            )}

            {/* VISTA 2: HISTORIAL CON FILTROS INTELIGENTES */}
            {activeTab === 'HISTORIAL' && (
                <div>
                    {/* BARRA DE FILTROS */}
                    <div style={{ display: 'flex', gap: 15, marginBottom: 15, flexWrap: 'wrap', background: 'white', padding: 15, borderRadius: 8, border: `1px solid ${THEME.border}`, alignItems:'center' }}>
                        
                        {/* 1. SELECTOR DE CLIENTES */}
                        <div>
                            <label style={{fontSize:11, fontWeight:'bold', display:'block', color:'#6B7280', marginBottom:4}}>CLIENTE</label>
                            <select 
                                value={filterClientId} 
                                onChange={e => setFilterClientId(e.target.value)}
                                style={{...selectStyle, minWidth: 200}}
                            >
                                <option value="">-- Todos los Clientes --</option>
                                {usuarios.map(u => (
                                    <option key={u.id} value={u.id}>
                                        {u.perfil?.razonSocial || u.username}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* 2. SELECTOR DE AÑO */}
                        <div>
                            <label style={{fontSize:11, fontWeight:'bold', display:'block', color:'#6B7280', marginBottom:4}}>AÑO</label>
                            <select 
                                value={filterYear} 
                                onChange={e => setFilterYear(e.target.value)}
                                style={selectStyle}
                            >
                                <option value="-1">Todos (Histórico)</option>
                                {YEARS.map(y => (
                                    <option key={y} value={y}>{y}</option>
                                ))}
                            </select>
                        </div>

                        {/* 3. SELECTOR DE MES */}
                        <div>
                            <label style={{fontSize:11, fontWeight:'bold', display:'block', color:'#6B7280', marginBottom:4}}>MES</label>
                            <select 
                                value={filterMonth} 
                                onChange={e => setFilterMonth(e.target.value)}
                                style={selectStyle}
                            >
                                <option value="-1">Todo el Año</option>
                                {MESES.map((mes, index) => (
                                    <option key={index} value={index}>{mes}</option>
                                ))}
                            </select>
                        </div>

                        {/* BOTÓN RESET */}
                        {(filterClientId || parseInt(filterMonth) !== -1 || parseInt(filterYear) !== -1) && (
                            <button 
                                onClick={() => { setFilterClientId(''); setFilterMonth('-1'); setFilterYear('-1'); }}
                                style={{marginTop: 15, background:'transparent', border:'1px solid #ddd', padding:'6px 12px', borderRadius:6, cursor:'pointer', fontSize:12, color:'#666'}}
                            >
                                Limpiar Filtros
                            </button>
                        )}
                    </div>

                    <div style={{ background: 'white', borderRadius: 12, boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', overflowX: 'auto' }}>
                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <th style={thStyle}>Fecha</th>
                                    <th style={thStyle}>Cliente</th>
                                    <th style={thStyle}>Monto</th>
                                    <th style={thStyle}>ID Ref</th>
                                    <th style={thStyle}>Acción</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pagosFiltrados.map(p => (
                                    <tr key={p.id}>
                                        <td style={{...tdStyle, fontWeight:'bold'}}>{new Date(p.fecha).toLocaleDateString()}</td>
                                        <td style={tdStyle}>
                                            {p.usuario?.perfil?.razonSocial || p.usuario?.username}
                                            <div style={{fontSize:11, color:'#6B7280'}}>{p.usuario?.email}</div>
                                        </td>
                                        <td style={tdStyle}>
                                            <span style={{background:'#D1FAE5', color:'#065F46', padding:'4px 10px', borderRadius:15, fontWeight:'bold'}}>
                                                ${(p.cantidad || 0).toLocaleString('es-MX')}
                                            </span>
                                        </td>
                                        <td style={{...tdStyle, color:'#9CA3AF', fontSize:11}}>{p.id.split('-')[0]}</td>
                                        <td style={tdStyle}>
                                            <button onClick={() => handleDeletePago(p.id)} style={{background: THEME.danger, color:'white', padding:'5px 10px', border:'none', borderRadius:4, cursor:'pointer'}}>🗑️</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {pagosFiltrados.length === 0 && <div style={{padding:30, textAlign:'center', color:'#666'}}>No se encontraron pagos con estos filtros.</div>}
                    </div>
                </div>
            )}

            {/* MODAL REGISTRAR PAGO */}
            {showModal && (
                <div style={{position:'fixed', top:0, left:0, width:'100%', height:'100%', background:'rgba(0,0,0,0.5)', display:'flex', justifyContent:'center', alignItems:'center', zIndex:1000}}>
                    <div style={{background:'white', padding:30, borderRadius:12, width:400, boxShadow:'0 10px 25px rgba(0,0,0,0.2)'}}>
                        <h3 style={{marginTop:0, color: THEME.primary}}>Registrar Nuevo Ingreso</h3>
                        <form onSubmit={handleCreatePago}>
                            <label style={{display:'block', marginBottom:5, fontWeight:'bold', fontSize:13}}>Cliente:</label>
                            <select 
                                value={newPago.usuarioId} 
                                onChange={(e) => setNewPago({...newPago, usuarioId: e.target.value})}
                                style={{width:'100%', padding:10, marginBottom:15, borderRadius:6, border:'1px solid #ddd'}}
                                required
                            >
                                <option value="">-- Seleccionar --</option>
                                {usuarios.map(u => (
                                    <option key={u.id} value={u.id}>
                                        {u.perfil?.razonSocial || u.username}
                                    </option>
                                ))}
                            </select>

                            <label style={{display:'block', marginBottom:5, fontWeight:'bold', fontSize:13}}>Monto ($):</label>
                            <input 
                                type="number" 
                                value={newPago.cantidad}
                                onChange={(e) => setNewPago({...newPago, cantidad: e.target.value})}
                                style={{width:'100%', padding:10, marginBottom:15, borderRadius:6, border:'1px solid #ddd', fontSize:16, fontWeight:'bold'}}
                                placeholder="0.00"
                                required
                            />

                            <label style={{display:'block', marginBottom:5, fontWeight:'bold', fontSize:13}}>Fecha:</label>
                            <input 
                                type="date" 
                                value={newPago.fecha}
                                onChange={(e) => setNewPago({...newPago, fecha: e.target.value})}
                                style={{width:'100%', padding:10, marginBottom:20, borderRadius:6, border:'1px solid #ddd'}}
                                required
                            />

                            <div style={{display:'flex', gap:10}}>
                                <button type="button" onClick={() => setShowModal(false)} style={{flex:1, padding:12, background:'#E5E7EB', border:'none', borderRadius:6, cursor:'pointer'}}>Cancelar</button>
                                <button type="submit" style={{flex:1, padding:12, background: THEME.success, color:'white', border:'none', borderRadius:6, fontWeight:'bold', cursor:'pointer'}}>Confirmar Pago</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </AdminLayout>
    );
}

export default AdminPagos;